import { createSlice } from '@reduxjs/toolkit';

export const patientSlice = createSlice({
  name: 'patient',
  initialState: {
    value: [],
  },
  reducers: {
    patient: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { patient } = patientSlice.actions;

export default patientSlice.reducer;
